<form name="CompanyPolicyTypeForm" (ngSubmit)="CompanyPolicyTypeForm.form.valid && SaveCompanyPolicyType()"
    #CompanyPolicyTypeForm="ngForm">
    <div class="card">
        <div class="card-header">
            <div class="card-title">Policy Type</div>
        </div>

        <div class="m-2 card-body">
            <div class="row">
                <div class="col-md-12 px-1">

                    <label>Title</label>
                    <input name="ESS_CompanyPolicyTypeTitle" class="form-control" placeholder="Ex. Policy 1"
                        [(ngModel)]="CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeTitle"
                        #ESS_CompanyPolicyTypeTitle="ngModel" required>
                    <div *ngIf="ESS_CompanyPolicyTypeTitle.hasError('required')" style="color: red;">
                        Please enter company policy type title.
                    </div>

                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button *ngIf="(this.common.PageRight.IsAdd && this.ID == 0) || (this.common.PageRight.IsEdit && this.ID > 0)" type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>